export default {
    attribute:{
        label:'联系我们：',
        size:'medium',
        showLable:true,
        showPhone:true,
        textColor: '#fff',
        cptTableData: [{ "name": "值", "value":"", "namekey": "value" }],
        url: '',
        width: 20,
        height: 20,
        left:10,
        fit: 'fill',
        preview: false,
        autoRotate: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)',
    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '{"value": "18565859261"}',//静态数据，必须为JSON格式
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },

}